import React from "react";
import "./WhoApply.css";

export default function WhoApply() {

    return(
    <div className="whoapply">
        <h1>Who Should Apply?</h1>
        <div className="empty">Quark Festival Ambassadors should be enthusiastic, passionate individuals who are genuinely excited about Quark's events, competitions, and talks. They need to be adept at utilizing social media for promotion, possess excellent communication skills, and maintain a friendly and approachable demeanor. Reliability and responsibility are crucial traits, as they represent Quark and should be punctual in their duties. Knowledge about Quark's offerings, networking abilities, and a strong commitment to their role are also essential qualities for prospective ambassadors.</div>
    </div>
    )
}

